import { render, staticRenderFns } from "./PrivacyPopup.vue?vue&type=template&id=52dd5d9c&scoped=true"
import script from "./PrivacyPopup.vue?vue&type=script&lang=js"
export * from "./PrivacyPopup.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPopup.vue?vue&type=style&index=0&id=52dd5d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd5d9c",
  null
  
)

export default component.exports